<script lang="ts">
  import { page } from "$app/stores";
  import Button from "@brave/leo/src/components/button/button.svelte";
  import type { ComponentProps } from "svelte";

  type $$Props = ComponentProps<Button<any, any, any>> &
    (
      | {
          // No event tracking
          eventCategory?: never;
          eventAction?: never;
          eventName?: never;
          eventValue?: never;
        }
      | {
          // Only eventAction and eventName (no category)
          eventCategory?: never;
          eventAction: string;
          eventName: string;
          eventValue?: string | number;
        }
      | {
          // Full event tracking with category
          eventCategory: string;
          eventAction: string;
          eventName: string;
          eventValue?: string | number;
        }
    );

  export let eventCategory: string | undefined =
    [$page?.url.pathname, $page?.url.searchParams.get("intent")].filter((x) => x).join("?") + " CTAs";
  export let eventAction: string | undefined = undefined;
  export let eventName: string | undefined = undefined;
  export let eventValue: string | number | undefined = undefined;

  let eventData;
  $: {
    if (eventCategory && eventAction && eventName) {
      eventData = ["trackEvent", eventCategory, eventAction, eventName, eventValue].filter((x) => x !== undefined);
    }
  }

  const handleClick = async (e: MouseEvent) => {
    // @ts-ignore
    let _paq = window._paq;
    if (_paq && eventData) {
      // Matomo mutates the array passed using shift(),
      // so we have to clone the eventData to preserve
      // the correct params are sent.
      _paq.push([...eventData]);
    }
    $$restProps.onClick?.(e);
  };
</script>

<Button {...$$restProps} onClick={handleClick}>
  <slot name="icon-before" slot="icon-before" />
  <slot name="loading" slot="loading">
    <slot />
  </slot>
  <slot />
  <slot name="icon-after" slot="icon-after" />
</Button>
